import styles from "./AboutUs.module.css";
import imageItem from "../../img/imgAboutUs.png";

function AboutUs(props) {
  return (
    <section {...props} className={styles.about_container}>
      <div className={styles.aboutUs}>
        <h1>Sobre nós</h1>
        <p>
          Pet shop Catarina nasceu da paixão pelos animais e do desejo de
          oferecer produtos de qualidade para tutores e seus pets. Desde nossa
          fundação, estamos comprometidos em proporcionar uma experiência única
          e acolhedora para todos os clientes. Nossa missão é ser o destino
          preferido dos amantes de pets, oferecendo uma ampla seleção de rações,
          acessórios, brinquedos e produtos de higiene para cães, gatos, aves e
          pequenos roedores. Valorizamos cada cliente e seu pet, oferecendo
          orientações e suporte individualizado. Trabalhamos apenas com marcas
          reconhecidas e produtos de alta qualidade. Venha nos visitar e faça
          parte da família Pet shop Catarina! 🐾
        </p>
      </div>
      <div className={styles.containerItem}>
        <div className={styles.circle_fill}></div>
        <img
          src={imageItem}
          alt="Imagem de animais fofos"
          className={styles.image_overlay}
        />
      </div>
    </section>
  );
}

export default AboutUs;
